import {
  ARTICLES_RANGE_FOR_PAGINATION,
  getSearchItem,
} from 'sly/resourceCenter/helpers';
import ReviewerPage from 'sly/resourceCenter/pages/Reviewer';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ReviewerPage;

export async function getServerSideProps({ params, resolvedUrl }) {
  const { api, store } = createApiClient(apiEndpoints);
  const { slug } = params;
  let search = '';
  if (resolvedUrl.indexOf('?') >= 0) {
    search = resolvedUrl.substring(resolvedUrl.indexOf('?'));
  }
  try {
    await Promise.allSettled(
      [
        api.getReviewer.asAction({
          'filters[slug][$eq]': encodeURIComponent(slug),
          populate: '*',
        }),
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
        api.getArticle.asAction({
          'filters[reviewer][slug][$eq]': encodeURIComponent(slug),
          'pagination[pageSize]': ARTICLES_RANGE_FOR_PAGINATION,
          'pagination[page]': getSearchItem(search, 'page-number') || 1,
          populate: '*',
          sort: 'id:desc',
        }),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
      params,
    },
  };
}
